module.exports = __webpack_public_path__ + "static/media/romania.517d31f2.png";